import { useForm } from '@mantine/form';
import {
  Button,
  Group,
  Modal,
  PasswordInput,
  TextInput,
  Select,
  Stack,
} from '@mantine/core';

export interface CreatePartnerStaffForm {
  name: string;
  email: string;
  role: string;
  username: string;
  password: string;
}

interface CreatePartnerStaffModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: ({ formValues }: { formValues: CreatePartnerStaffForm }) => void;
  isPending: boolean;
}

export default function CreatePartnerStaffModal({
  opened,
  onClose,
  onConfirm,
  isPending,
}: CreatePartnerStaffModalProps) {
  const form = useForm<CreatePartnerStaffForm>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      email: '',
      role: '',
      username: '',
      password: '',
    },
    validate: {
      name: (value) => (value ? null : ' '),
      email: (value) => (value ? null : ' '),
      role: (value) => (value ? null : ' '),
      username: (value) => (value ? null : ' '),
      password: (value) => (value ? null : ' '),
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="新增廠商後台管理員"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack>
        <form
          onSubmit={form.onSubmit((values: CreatePartnerStaffForm) =>
            onConfirm({ formValues: values }),
          )}
        >
          <TextInput
            withAsterisk
            label="人員名稱"
            placeholder="請輸入人員名稱"
            key={form.key('name')}
            {...form.getInputProps('name')}
          />
          <TextInput
            mt="md"
            withAsterisk
            label="Email"
            placeholder="請輸入Email"
            key={form.key('email')}
            {...form.getInputProps('email')}
          />
          <Select
            mt="md"
            withAsterisk
            label="廠商後台權限"
            placeholder="請選擇廠商後台權限"
            data={[
              { value: 'Viewer', label: '檢視者' },
              { value: 'Editor', label: '編輯者' },
            ]}
            {...form.getInputProps('role')}
          />
          <TextInput
            mt="md"
            withAsterisk
            label="帳號"
            placeholder="請輸入帳號"
            key={form.key('username')}
            {...form.getInputProps('username')}
          />
          <PasswordInput
            mt="md"
            withAsterisk
            label="密碼"
            placeholder="請輸入密碼"
            key={form.key('password')}
            {...form.getInputProps('password')}
          />
          <Group justify="flex-end" mt="md">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400}>
              新增
            </Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  );
}
